import React, {useContext} from 'react';
import config from '../../services/config.json'
import SimpleContext from '../context/SimpleContext';
// import CATEGORY_THREE from './Category_Three';

const CATEGORY_TWO = ({slug, isend, gname, catL3}) => {

    const context = useContext(SimpleContext);
    
    // const filteredcategories3 = context.category3C.filter(product => product.ParentRef === catL3);

    return ( 

        <div className="productsmain">
            <div onClick={() => context.handleShowCategoryLevelTwoProducts(catL3, gname)} className="item">
                    <img src={`${config.CategoryLevel2Pictures}/${slug}.jpg`} 
                    className="cat3_img" 
                    id="img" 
                    alt="" 
                    />
            </div>
            <div className="second-txt" >
                <p>{`${gname}`}</p>
            </div>
        </div>


);
}

export default CATEGORY_TWO;


// {/* {
//     isend===1? */}
//     {/* <div className="cat2"> */}
//         {/* <div className="banner_cat2_img"> */}
        
//             {/* <div onClick={() => context.handleShowCategoryLevelTwoProducts(catL3)} className="item item--third">
//                 <img className="cat3_img" id="img" 
//                 src={`${config.CategoryLevel2Pictures}/${slug}.jpg`} 
//                 alt="" 
//                 />
//             </div>
//             <div className="second-txt" >
//                 <p>{`${gname}`}</p>
//             </div> */}

//         {/* </div> */}
//     {/* </div> */}
//     {/* :
//     <div className="cat_baners_div">
    
//         <div className="cat2">
//             <div className="top_cat2_orange" onClick={() => context.handleFilterByCatName(gname)} >{`${gname}`}</div>
//             <div className="banner_cat3">
//                 {
//                    filteredcategories3.length?
//                    filteredcategories3.map(cat2 => 
//                         <div className="lev3cat" key={cat2.ID}>
//                             <CATEGORY_THREE 
//                             slug = {cat2.ImgUrl}
//                             gname = {cat2.GroupName}
//                             catID = {cat2.ID}
//                             />
//                         </div>
//                     ):null
//                 }
//             </div>
//         </div>
//     </div>
// } */}